/* rivplay — componentes del portafolio de Bryan Riveros.
   Portados desde el design system rivplay (components/src/index.jsx). */
import React, { useState, useEffect, useRef, useCallback } from "react";

const cx = (...a) => a.filter(Boolean).join(' ');
const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------------------------------------------------------------- Icon */
const PATHS = {
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  'arrow-up-right': 'M7 17L17 7M8 7h9v9',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  mail: 'M4 6h16v12H4zM4 7l8 6 8-6',
  copy: 'M9 9h10v11H9zM5 15V4h10',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  sun: 'M12 8a4 4 0 100 8 4 4 0 000-8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 019.5 4 8 8 0 1020 14.5z',
  code: 'M8 7l-5 5 5 5M16 7l5 5-5 5M14 4l-4 16',
  profile: 'M4 4h16v16H4zM8 10v6M8 7.5v.01M12 16v-4a2 2 0 014 0v4M12 12v4',
  chat: 'M4 5h16v11H9l-5 4z',
  pin: 'M12 21s-7-6.2-7-11.5A7 7 0 0112 2.5a7 7 0 017 7C19 14.8 12 21 12 21zM12 7a2.5 2.5 0 100 5 2.5 2.5 0 000-5z',
  globe: 'M12 3a9 9 0 100 18 9 9 0 000-18zM3 12h18M12 3c2.5 2.7 3.5 5.7 3.5 9s-1 6.3-3.5 9c-2.5-2.7-3.5-5.7-3.5-9s1-6.3 3.5-9z',
  server: 'M4 4h16v6H4zM4 14h16v6H4zM8 7h.01M8 17h.01',
  shield: 'M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6zM8.5 12l2.5 2.5 4.5-5',
  zap: 'M13 2L4 14h7l-1 8 9-12h-7z',
  rocket: 'M5 15c-1.5 1.5-2 5-2 5s3.5-.5 5-2M9 15l-3-3c1-4 4.5-8.5 12-9-.5 7.5-5 11-9 12zM14.5 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z',
  database: 'M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  cloud: 'M7 18a4.5 4.5 0 01-.6-9A6 6 0 0118 8.5 4.8 4.8 0 0117.5 18z',
  gamepad: 'M6 8h12a4 4 0 014 4v1a4 4 0 01-7 2.6L14 14h-4l-1 1.6A4 4 0 012 13v-1a4 4 0 014-4zM7 11v3M5.5 12.5h3M16 11.5h.01M18 13.5h.01',
  phone: 'M7 2h10v20H7zM11 18h2',
  clock: 'M12 3a9 9 0 100 18 9 9 0 000-18zM12 7v5l3 2',
  terminal: 'M3 4h18v16H3zM7 9l3 3-3 3M12 15h5',
  pr: 'M6 3v12M6 21a2 2 0 100-4 2 2 0 000 4zM6 7a2 2 0 100-4 2 2 0 000 4zM18 21a2 2 0 100-4 2 2 0 000 4zM18 17V9a3 3 0 00-3-3h-4M13 3.5L10.5 6 13 8.5',
  layers: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5',
  play: 'M7 4l13 8-13 8z',
  image: 'M3 5h18v14H3zM3 16l5-5 5 5M13 13l3-3 5 5M15.5 8.5h.01',
  realtime: 'M3 12h4l2-5 4 10 2-5h6',
  plug: 'M9 3v5M15 3v5M6 8h12v3a6 6 0 01-12 0zM12 17v4',
  menu: 'M4 7h16M4 12h16M4 17h16',
  close: 'M6 6l12 12M18 6L6 18',
  file: 'M6 3h8l4 4v14H6zM14 3v4h4',
  upload: 'M12 16V4M7 9l5-5 5 5M5 20h14',
  gauge: 'M12 14l4-4M3.5 17a9 9 0 1117 0',
  browser: 'M3 5h18v14H3zM3 9h18M6 7h.01M8.5 7h.01',
  key: 'M14.5 9.5a4.5 4.5 0 11-3.3-4.3M14.5 9.5L21 16v3h-3v-2h-2v-2h-2l-1.3-1.3M8 10h.01',
  hourglass: 'M6 3h12M6 21h12M7 3c0 5 10 5 10 9s-10 4-10 9M17 3c0 5-10 5-10 9',
};
export function Icon({ name, size = 18, strokeWidth = 1.6, className, title, ...rest }) {
  const d = PATHS[name] || PATHS.code;
  return (
    <svg
      className={cx('rp-icon', className)}
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}
Icon.names = Object.keys(PATHS);

/* ---------------------------------------------------------------- Monogram */
export function Monogram({ size = 32, withWord = false, className }) {
  return (
    <span className={cx('rp-logo', className)} aria-label="rivplay — Bryan Riveros">
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <rect x="0.5" y="0.5" width="31" height="31" rx="8" className="rp-logo-box" />
        <path d="M8 9h5.2a3.3 3.3 0 010 6.6H8zM8 15.6h5.8a3.7 3.7 0 010 7.4H8zM8 9v14" className="rp-logo-stroke" />
        <path d="M19 23V9h4.2a3.5 3.5 0 010 7H19M22.4 16l3.6 7" className="rp-logo-stroke" />
        <circle cx="26" cy="9" r="1.8" className="rp-logo-dot" />
      </svg>
      {withWord && <span className="rp-logo-word">rivplay<span className="rp-logo-tld">.dev</span></span>}
    </span>
  );
}

/* ---------------------------------------------------------------- Button */
export function Button({ variant = 'primary', size = 'md', icon, iconRight, href, className, children, ...rest }) {
  const cls = cx('rp-btn', 'rp-btn-' + variant, size === 'sm' && 'rp-btn-sm', !children && 'rp-btn-icon', className);
  const inner = (
    <>
      {icon && <Icon name={icon} size={size === 'sm' ? 16 : 18} />}
      {children && <span>{children}</span>}
      {iconRight && <Icon name={iconRight} size={size === 'sm' ? 16 : 18} className="rp-btn-trail" />}
    </>
  );
  return href
    ? <a className={cls} href={href} {...rest}>{inner}</a>
    : <button type="button" className={cls} {...rest}>{inner}</button>;
}

/* ---------------------------------------------------------------- StatusBadge */
export function StatusBadge({ children, pulse = true, className }) {
  return (
    <span className={cx('rp-status', className)}>
      <span className={cx('rp-dot', pulse && 'rp-dot-pulse')} aria-hidden="true" />
      <span>{children}</span>
    </span>
  );
}

/* ---------------------------------------------------------------- Chip */
export function Chip({ tier = 'secondary', icon, children, className }) {
  return (
    <span className={cx('rp-chip', 'rp-chip-' + tier, className)}>
      {icon && <Icon name={icon} size={14} />}
      {children}
    </span>
  );
}

/* ---------------------------------------------------------------- SectionHeader */
export function SectionHeader({ index, eyebrow, title, lead, align = 'left', id }) {
  return (
    <header className={cx('rp-sechead', align === 'center' && 'rp-sechead-center')}>
      <p className="rp-eyebrow">
        {index && <span className="rp-eyebrow-idx">{index}</span>}
        <span className="rp-eyebrow-rule" aria-hidden="true" />
        {eyebrow}
      </p>
      <h2 className="rp-h1" id={id}>{title}</h2>
      {lead && <p className="rp-lead">{lead}</p>}
    </header>
  );
}

/* ---------------------------------------------------------------- Reveal */
export function Reveal({ as: Tag = 'div', delay = 0, className, children, ...rest }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion() || !('IntersectionObserver' in window) || document.documentElement.hasAttribute('data-reveal-static')) { setShown(true); return; }
    const io = new IntersectionObserver((ents) => {
      ents.forEach((e) => { if (e.isIntersecting) { setShown(true); io.disconnect(); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={cx('rp-reveal', shown && 'is-in', className)} style={{ transitionDelay: delay + 'ms' }} {...rest}>
      {children}
    </Tag>
  );
}

/* ---------------------------------------------------------------- Toggles */
export function LangToggle({ lang = 'es', onChange }) {
  return (
    <div className="rp-seg" role="group" aria-label="Idioma / Language">
      {['es', 'en'].map((l) => (
        <button key={l} type="button" className={cx('rp-seg-btn', lang === l && 'is-on')} aria-pressed={lang === l} onClick={() => onChange && onChange(l)}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export function ThemeToggle({ theme, onChange }) {
  const [t, setT] = useState(theme || (typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme')) || 'dark');
  useEffect(() => { if (theme) setT(theme); }, [theme]);
  const next = t === 'dark' ? 'light' : 'dark';
  const flip = () => {
    document.documentElement.setAttribute('data-theme', next);
    setT(next);
    onChange && onChange(next);
  };
  return (
    <button type="button" className="rp-btn rp-btn-ghost rp-btn-icon rp-btn-sm" onClick={flip} aria-label={t === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}>
      <Icon name={t === 'dark' ? 'sun' : 'moon'} size={16} />
    </button>
  );
}

/* ---------------------------------------------------------------- NavBar */
export function NavBar({ links = [], lang = 'es', onLang, cvLabel = 'Descargar CV', cvHref = '#cv', active, sticky = true }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8);
    on(); window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);
  return (
    <nav className={cx('rp-nav', sticky && 'rp-nav-sticky', scrolled && 'is-scrolled', open && 'is-open')} aria-label="Principal">
      <div className="rp-nav-in">
        <a href="#top" className="rp-nav-brand"><Monogram size={30} withWord /></a>
        <ul className="rp-nav-links">
          {links.map((l) => (
            <li key={l.href}><a href={l.href} className={cx('rp-nav-link', active === l.href && 'is-active')} onClick={() => setOpen(false)}>{l.label}</a></li>
          ))}
        </ul>
        <div className="rp-nav-actions">
          <LangToggle lang={lang} onChange={onLang} />
          <ThemeToggle />
          <Button variant="secondary" size="sm" icon="download" href={cvHref} className="rp-nav-cv">{cvLabel}</Button>
          <button type="button" className="rp-btn rp-btn-ghost rp-btn-icon rp-btn-sm rp-nav-burger" aria-expanded={open} aria-label="Menú" onClick={() => setOpen(!open)}>
            <Icon name={open ? 'close' : 'menu'} size={18} />
          </button>
        </div>
      </div>
    </nav>
  );
}

/* ---------------------------------------------------------------- StatBar */
export function StatBar({ items = [] }) {
  return (
    <dl className="rp-stats">
      {items.map((s, i) => (
        <div className="rp-stat" key={i}>
          <dt className="rp-stat-label">{s.label}</dt>
          <dd className="rp-stat-value">{s.value}</dd>
        </div>
      ))}
    </dl>
  );
}

/* ---------------------------------------------------------------- Device frames */
export function BrowserFrame({ url = 'rivplay.dev', children, className, style }) {
  return (
    <div className={cx('rp-browser', className)} style={style}>
      <div className="rp-browser-bar" aria-hidden="true">
        <span className="rp-browser-dots"><i /><i /><i /></span>
        <span className="rp-browser-url">{url}</span>
      </div>
      <div className="rp-browser-screen">{children}</div>
    </div>
  );
}
export function PhoneFrame({ children, className, style }) {
  return (
    <div className={cx('rp-phone', className)} style={style}>
      <div className="rp-phone-screen">
        <span className="rp-phone-notch" aria-hidden="true" />
        {children}
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------- MockScreen (placeholder elegante) */
const TILE_TONES = ['#d9c7b0', '#a7b8c9', '#c9a9a0', '#b7c4a4', '#e0d6c8', '#9fb0a8'];
function MockMarketplace() {
  return (
    <div className="rp-mk rp-mk-market">
      <div className="rp-mk-top"><span className="rp-mk-logo">roperito</span><span className="rp-mk-search" /><span className="rp-mk-avatar" /></div>
      <div className="rp-mk-chips">{['Todo', 'Mujer', 'Hombre', 'Vintage'].map((c, i) => <span key={c} className={i === 0 ? 'is-on' : ''}>{c}</span>)}</div>
      <div className="rp-mk-grid">
        {TILE_TONES.map((c, i) => (
          <div key={i} className="rp-mk-item">
            <span className="rp-mk-photo" style={{ background: `linear-gradient(160deg, ${c}, ${c}99)` }}><i /></span>
            <span className="rp-mk-line" /><span className="rp-mk-price">$ {(i + 2) * 3}.990</span>
          </div>
        ))}
      </div>
      <div className="rp-mk-chat"><span className="rp-mk-bubble">¿Sigue disponible?</span><span className="rp-mk-bubble is-me">¡Sí! Te la reservo</span></div>
    </div>
  );
}
function MockTennis() {
  const rows = [['R. Soto', '6 6'], ['M. Paz', '3 4'], ['D. Lara', '7 6'], ['J. Rey', '5 2']];
  return (
    <div className="rp-mk rp-mk-tennis">
      <p className="rp-mk-kicker">Circuito Primavera</p>
      <p className="rp-mk-title">Cuadro principal</p>
      <div className="rp-mk-tabs"><span className="is-on">Cuadro</span><span>Ranking</span><span>Pagos</span></div>
      {[0, 1].map((m) => (
        <div key={m} className="rp-mk-match">
          {rows.slice(m * 2, m * 2 + 2).map(([n, sc], j) => (
            <div key={n} className={cx('rp-mk-player', j === 0 && 'is-win')}><span className="rp-mk-ball" />{n}<b>{sc}</b></div>
          ))}
        </div>
      ))}
      <div className="rp-mk-final"><span>Final · Dom 16:00</span></div>
      <span className="rp-mk-cta">Inscribirme · MercadoPago</span>
    </div>
  );
}
function MockCar() {
  return (
    <div className="rp-mk rp-mk-car">
      <p className="rp-mk-kicker">Mi vehículo</p>
      <div className="rp-mk-carcard"><span className="rp-mk-carshape" /><div><b>Sedán · ABCD-12</b><span>84.230 km</span></div></div>
      {[['Revisión técnica', 'en 12 días', true], ['Cambio de aceite', 'en 1.800 km'], ['Permiso de circulación', 'marzo']].map(([a, b, hot]) => (
        <div key={a} className={cx('rp-mk-rem', hot && 'is-hot')}><span className="rp-mk-bell" /><div><b>{a}</b><span>{b}</span></div></div>
      ))}
    </div>
  );
}
function MockDashboard() {
  return (
    <div className="rp-mk rp-mk-dash">
      <div className="rp-mk-side">{[0, 1, 2, 3, 4].map((i) => <span key={i} className={i === 1 ? 'is-on' : ''} />)}</div>
      <div className="rp-mk-main">
        <div className="rp-mk-top"><span className="rp-mk-h">Auditorías</span><span className="rp-mk-pill">+ Nueva</span></div>
        {[['Caso 1042', 'Asignado', 1], ['Caso 1041', 'En revisión', 2], ['Caso 1040', 'Cerrado', 0], ['Caso 1039', 'Asignado', 1]].map(([a, b, k]) => (
          <div key={a} className="rp-mk-row"><span className="rp-mk-av" /><b>{a}</b><span className="rp-mk-line" /><em className={'k' + k}>{b}</em></div>
        ))}
      </div>
    </div>
  );
}
function MockGame({ title = 'Roam Survival' }) {
  return (
    <div className="rp-mk rp-mk-game">
      <span className="rp-mk-sun" />
      <span className="rp-mk-mtn rp-mk-mtn-1" /><span className="rp-mk-mtn rp-mk-mtn-2" /><span className="rp-mk-forest" />
      <div className="rp-mk-gametitle"><small>Survival · 3D</small>{title}</div>
    </div>
  );
}
const MOCKS = { marketplace: MockMarketplace, tennis: MockTennis, car: MockCar, dashboard: MockDashboard, game: MockGame };
export function MockScreen({ variant = 'marketplace', src, alt = '', tag = 'Placeholder', title }) {
  if (src) return <img className="rp-shot" src={src} alt={alt} loading="lazy" />;
  const M = MOCKS[variant] || MockMarketplace;
  return (
    <div className="rp-mock" role="img" aria-label={alt || 'Placeholder de captura: ' + variant}>
      <M title={title} />
      {tag && <span className="rp-mock-tag">{tag}</span>}
    </div>
  );
}

/* ---------------------------------------------------------------- HeroShowcase */
export function HeroShowcase({ web = { url: 'roperito.[dominio]', variant: 'marketplace' }, mobile = { variant: 'tennis' }, game = { variant: 'game', title: 'Roam Survival' }, tag = 'Placeholder' }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion()) return;
    const host = el.closest('[data-parallax-host]') || el;
    let raf = 0;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - (r.left + r.width / 2)) / r.width;
      const y = (e.clientY - (r.top + r.height / 2)) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { el.style.setProperty('--px', Math.max(-1, Math.min(1, x)).toFixed(3)); el.style.setProperty('--py', Math.max(-1, Math.min(1, y)).toFixed(3)); });
    };
    const leave = () => { el.style.setProperty('--px', 0); el.style.setProperty('--py', 0); };
    host.addEventListener('mousemove', move); host.addEventListener('mouseleave', leave);
    return () => { host.removeEventListener('mousemove', move); host.removeEventListener('mouseleave', leave); cancelAnimationFrame(raf); };
  }, []);
  return (
    <div className="rp-showcase" ref={ref} aria-label="Proyectos: Roperito (web), Tenapp (móvil) y Roam Survival (juego)">
      <span className="rp-showcase-glow" aria-hidden="true" />
      <div className="rp-layer rp-layer-web" style={{ '--d': 10 }}>
        <BrowserFrame url={web.url}><MockScreen variant={web.variant} src={web.src} alt="Roperito" tag={tag} /></BrowserFrame>
      </div>
      <div className="rp-layer rp-layer-game" style={{ '--d': 22 }}>
        <div className="rp-gamecard"><MockScreen variant={game.variant} src={game.src} title={game.title} alt="Roam Survival" tag={null} /></div>
      </div>
      <div className="rp-layer rp-layer-phone" style={{ '--d': 34 }}>
        <PhoneFrame><MockScreen variant={mobile.variant} src={mobile.src} alt="Tenapp" tag={null} /></PhoneFrame>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------- BeforeAfter */
export function BeforeAfter({ title, before, after, result, className }) {
  const Col = ({ side, d }) => (
    <div className={cx('rp-ba-col', 'is-' + side)}>
      <p className="rp-ba-tag">{side === 'before' ? 'Antes' : 'Después'}</p>
      <ul className="rp-ba-steps">
        {d.steps.map((s, i) => (
          <li key={i}><span className="rp-ba-icon"><Icon name={s.icon} size={16} /></span><span>{s.text}</span></li>
        ))}
      </ul>
      {d.note && <p className="rp-ba-note">{d.note}</p>}
    </div>
  );
  return (
    <figure className={cx('rp-ba', className)}>
      {title && <figcaption className="rp-ba-title">{title}</figcaption>}
      <div className="rp-ba-cols">
        <Col side="before" d={before} />
        <span className="rp-ba-arrow" aria-hidden="true"><Icon name="arrow-right" size={18} /></span>
        <Col side="after" d={after} />
      </div>
      {result && <p className="rp-ba-result"><Icon name="check" size={16} />{result}</p>}
    </figure>
  );
}

/* ---------------------------------------------------------------- Media placeholder */
export function MediaPlaceholder({ label = 'Captura / mockup', hint, ratio = '16 / 10', icon = 'image', className }) {
  return (
    <div className={cx('rp-ph', className)} style={{ aspectRatio: ratio }} role="img" aria-label={'Placeholder: ' + label}>
      <Icon name={icon} size={22} />
      <span className="rp-ph-label">{label}</span>
      {hint && <span className="rp-ph-hint">{hint}</span>}
    </div>
  );
}

/* ---------------------------------------------------------------- Card (hover glow) */
function useGlow(tilt) {
  return useCallback((e) => {
    const el = e.currentTarget, r = el.getBoundingClientRect();
    const x = e.clientX - r.left, y = e.clientY - r.top;
    el.style.setProperty('--mx', x + 'px');
    el.style.setProperty('--my', y + 'px');
    if (tilt && !prefersReducedMotion()) {
      el.style.setProperty('--rx', (((y / r.height) - 0.5) * -2 * tilt).toFixed(2) + 'deg');
      el.style.setProperty('--ry', (((x / r.width) - 0.5) * 2 * tilt).toFixed(2) + 'deg');
    }
  }, [tilt]);
}
const resetTilt = (e) => { e.currentTarget.style.setProperty('--rx', '0deg'); e.currentTarget.style.setProperty('--ry', '0deg'); };
export function Card({ as: Tag = 'div', className, interactive = true, tilt = 0, children, ...rest }) {
  const glow = useGlow(tilt);
  return (
    <Tag className={cx('rp-card', interactive && 'is-interactive', tilt && 'is-tilt', className)} onMouseMove={interactive ? glow : undefined} onMouseLeave={tilt ? resetTilt : undefined} {...rest}>
      {children}
    </Tag>
  );
}

/* ---------------------------------------------------------------- ProjectCard */
export function ProjectCard({ size = 'md', reverse = false, kicker, title, impact, tags = [], links = [], media, details, badges, className }) {
  return (
    <Card as="article" tilt={size === 'lg' ? 2 : 4} className={cx('rp-proj', 'rp-proj-' + size, reverse && 'is-rev', className)}>
      {media && (
        <div className="rp-proj-media">
          <div className="rp-proj-media-in">{media}</div>
          {details && details.length > 0 && (
            <ul className="rp-proj-reveal">
              {details.map((d) => <li key={d}><Icon name="check" size={14} />{d}</li>)}
            </ul>
          )}
        </div>
      )}
      <div className="rp-proj-body">
        {kicker && <p className="rp-proj-kicker">{kicker}</p>}
        <h3 className={size === 'lg' ? 'rp-h2' : 'rp-h3'}>{title}</h3>
        {impact && <p className="rp-proj-impact">{impact}</p>}
        {badges && <div className="rp-proj-badges">{badges}</div>}
        {tags.length > 0 && (
          <ul className="rp-chips" aria-label="Tecnologías">
            {tags.map((t) => <li key={t}><Chip>{t}</Chip></li>)}
          </ul>
        )}
        {links.length > 0 && (
          <div className="rp-proj-links">
            {links.map((l) => (
              <a key={l.label} href={l.href || '#'} className={cx('rp-link', l.muted && 'is-muted')}>
                {l.label}<Icon name={l.icon || 'arrow-up-right'} size={14} />
              </a>
            ))}
          </div>
        )}
      </div>
    </Card>
  );
}
export function BentoGrid({ children, className }) {
  return <div className={cx('rp-bento', className)}>{children}</div>;
}
export function StoreBadge({ store = 'Steam', href = '#', icon = 'play' }) {
  return (
    <a className="rp-store" href={href}>
      <Icon name={icon} size={16} />
      <span><small>Disponible en</small>{store}</span>
    </a>
  );
}

/* ---------------------------------------------------------------- Timeline */
export function Timeline({ items = [] }) {
  return (
    <ol className="rp-tl">
      {items.map((it, i) => (
        <li key={i} className={cx('rp-tl-item', it.current && 'is-current')}>
          <span className="rp-tl-node" aria-hidden="true" />
          <div className="rp-tl-head">
            <p className="rp-tl-date">{it.dates}{it.current && <span className="rp-tl-now">● actual</span>}</p>
            <h3 className="rp-h3">{it.role} <span className="rp-tl-at">· {it.company}</span></h3>
            {it.org && <p className="rp-tl-org">{it.org}</p>}
          </div>
          <ul className="rp-tl-wins">
            {it.wins.map((w, j) => (
              <li key={j}><Icon name="arrow-right" size={14} className="rp-tl-bullet" /><span><strong>{w.verb}</strong> {w.text}</span></li>
            ))}
          </ul>
          {it.stack && <ul className="rp-chips rp-tl-stack">{it.stack.map((t) => <li key={t}><Chip>{t}</Chip></li>)}</ul>}
          {it.highlight && <div className="rp-tl-hl"><BeforeAfter {...it.highlight} /></div>}
        </li>
      ))}
    </ol>
  );
}

/* ---------------------------------------------------------------- StackGrid */
export function StackGrid({ groups = [] }) {
  return (
    <div className="rp-stack">
      {groups.map((g) => (
        <Card key={g.name} className={cx('rp-stack-group', g.primary && 'is-primary', g.wide && 'is-wide')}>
          <div className="rp-stack-head">
            <span className="rp-stack-icon"><Icon name={g.icon} size={18} /></span>
            <h3 className="rp-stack-name">{g.name}</h3>
            {g.primary && <span className="rp-stack-flag">core</span>}
          </div>
          <ul className="rp-chips">
            {g.items.map((it) => {
              const o = typeof it === 'string' ? { name: it } : it;
              return <li key={o.name}><Chip tier={o.core ? 'primary' : 'secondary'}>{o.name}</Chip></li>;
            })}
          </ul>
        </Card>
      ))}
    </div>
  );
}

/* ---------------------------------------------------------------- PrincipleCard */
export function PrincipleCard({ icon = 'zap', index, title, children }) {
  return (
    <Card className="rp-principle">
      <div className="rp-principle-top">
        <span className="rp-principle-icon"><Icon name={icon} size={20} /></span>
        {index && <span className="rp-principle-idx">{index}</span>}
      </div>
      <h3 className="rp-h3">{title}</h3>
      <p className="rp-body-s">{children}</p>
    </Card>
  );
}

/* ---------------------------------------------------------------- CodeBlock */
const KW = /^(import|from|export|const|let|return|await|async|new|if|throw|class|extends|implements|function|public|private|readonly|true|false|null|undefined)$/;
function highlight(code) {
  const out = [];
  const re = /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|('[^'\n]*'|"[^"\n]*"|`[^`]*`)|(@\w+)|\b([A-Z][A-Za-z0-9_]*)\b|\b([a-z_]\w*)\b|(\d+)/g;
  let last = 0, m, i = 0;
  while ((m = re.exec(code))) {
    if (m.index > last) out.push(code.slice(last, m.index));
    const [tok] = m;
    let cls = null;
    if (m[1]) cls = 'c'; else if (m[2]) cls = 's'; else if (m[3]) cls = 't'; else if (m[4]) cls = 't';
    else if (m[5] && KW.test(m[5])) cls = 'k'; else if (m[6]) cls = 'n';
    out.push(cls ? <span key={i++} className={'rp-tok-' + cls}>{tok}</span> : tok);
    last = m.index + tok.length;
  }
  if (last < code.length) out.push(code.slice(last));
  return out;
}
export function CodeBlock({ filename, lang = 'ts', code = '', highlightLines = [], className }) {
  const [copied, setCopied] = useState(false);
  const lines = code.replace(/\n$/, '').split('\n');
  const copy = () => {
    try { navigator.clipboard.writeText(code); } catch (e) { /* sin portapapeles */ }
    setCopied(true); setTimeout(() => setCopied(false), 1400);
  };
  return (
    <figure className={cx('rp-code', className)}>
      <figcaption className="rp-code-bar">
        <span className="rp-code-file"><Icon name="file" size={14} />{filename}</span>
        <span className="rp-code-lang">{lang}</span>
        <button type="button" className="rp-code-copy" onClick={copy} aria-label="Copiar código">
          <Icon name={copied ? 'check' : 'copy'} size={14} />
        </button>
      </figcaption>
      <pre className="rp-code-body"><code>
        {lines.map((ln, i) => (
          <span key={i} className={cx('rp-code-line', highlightLines.includes(i + 1) && 'is-hl')}>
            <span className="rp-code-no" aria-hidden="true">{i + 1}</span>{highlight(ln)}{'\n'}
          </span>
        ))}
      </code></pre>
    </figure>
  );
}

/* ---------------------------------------------------------------- DecisionBlock (caso de estudio) */
export function DecisionBlock({ index, title, problem, decision, result, diagram, code }) {
  return (
    <section className="rp-decision">
      <div className="rp-decision-text">
        <p className="rp-eyebrow"><span className="rp-eyebrow-idx">{index}</span><span className="rp-eyebrow-rule" aria-hidden="true" />Decisión técnica</p>
        <h3 className="rp-h2">{title}</h3>
        <dl className="rp-decision-dl">
          <div><dt>Problema</dt><dd>{problem}</dd></div>
          <div><dt>Decisión</dt><dd>{decision}</dd></div>
          {result && <div><dt>Resultado</dt><dd>{result}</dd></div>}
        </dl>
      </div>
      <div className="rp-decision-visual">
        {diagram}
        {code}
      </div>
    </section>
  );
}

/* ---------------------------------------------------------------- ContactPanel */
export function ContactPanel({ title = '¿Construimos algo?', lead, email = 'riveros.bryan@gmail.com', links = [], location, cvLabel = 'Descargar CV', cvHref = '#cv', copyLabel = 'Copiar', copiedLabel = 'Copiado' }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    try { navigator.clipboard.writeText(email); } catch (e) { /* sin portapapeles */ }
    setCopied(true); setTimeout(() => setCopied(false), 1600);
  };
  return (
    <div className="rp-contact">
      <h2 className="rp-display-l">{title}</h2>
      {lead && <p className="rp-lead">{lead}</p>}
      <div className="rp-contact-mail">
        <a href={'mailto:' + email} className="rp-contact-addr"><Icon name="mail" size={20} />{email}</a>
        <button type="button" className={cx('rp-btn rp-btn-secondary rp-btn-sm', copied && 'is-done')} onClick={copy} aria-live="polite">
          <Icon name={copied ? 'check' : 'copy'} size={16} /><span>{copied ? copiedLabel : copyLabel}</span>
        </button>
      </div>
      <div className="rp-contact-row">
        {links.map((l) => <Button key={l.label} variant="ghost" icon={l.icon} iconRight="arrow-up-right" href={l.href}>{l.label}</Button>)}
        <Button variant="primary" icon="download" href={cvHref}>{cvLabel}</Button>
      </div>
      {location && <p className="rp-contact-loc"><Icon name="pin" size={14} />{location}</p>}
    </div>
  );
}

/* ---------------------------------------------------------------- Footer */
export function Footer({ text = 'Diseñado y desarrollado por Bryan Riveros', year = new Date().getFullYear(), domain = 'rivplay.dev' }) {
  return (
    <footer className="rp-footer">
      <span>{text} · {year}</span>
      <span className="rp-footer-meta"><span className="rp-dot" aria-hidden="true" />{domain}</span>
    </footer>
  );
}

